import { escape } from 'lodash'
import { parseJsonSafe, stringifyJsonSafe } from '@feedyou/utils'

import { dialog } from '../../../lib/bootbox'

export async function showContext(context: string): Promise<void> {
  const stringifiedJson = stringifyJsonSafe({
    json: parseJsonSafe(context, {}),
    options: { space: 2, replacer: null }
  })

  await dialog({
    title: `Query context`,
    message: `<pre>${escape(stringifiedJson)}</pre>`,
    size: 'lg',
    buttons: {
      close: {
        label: 'Close',
        className: 'btn-secondary',
        callback: () => {
          return true
        }
      }
    }
  })
}
